/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Different error types the Container may report out to the Host
 */
export var ContainerErrorType;
(function (ContainerErrorType) {
    /**
     * Some error, most likely an exception caught by runtime and propagated to container as critical error
     */
    ContainerErrorType["genericError"] = "genericError";
    /**
     * Throttling error from server. Server is busy and is asking not to reconnect for some time
     */
    ContainerErrorType["throttlingError"] = "throttlingError";
    /**
     * Data loss error detected by Container / DeltaManager. Likely points to storage issue.
     */
    ContainerErrorType["dataCorruptionError"] = "dataCorruptionError";
    /**
     * Error encountered when processing an operation. May correlate with data corruption.
     */
    ContainerErrorType["dataProcessingError"] = "dataProcessingError";
    /**
     * Error indicating an API is being used improperly resulting in an invalid operation.
     */
    ContainerErrorType["usageError"] = "usageError";
    /**
     * Error indicating an client session has expired. Currently this only happens when GC is allowed on a document and
     * aids in safely deleting unused objects.
     */
    ContainerErrorType["clientSessionExpiredError"] = "clientSessionExpiredError";
})(ContainerErrorType || (ContainerErrorType = {}));
//# sourceMappingURL=error.js.map